import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=aa192b78&"
import script from "./ContactPage.vue?vue&type=script&lang=js&"
export * from "./ContactPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContactHeader: require('/vercel/path0/components/contact/ContactHeader.vue').default,ContentPage: require('/vercel/path0/components/pages/ContentPage.vue').default})
